"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class EmailInfo {
}
exports.default = EmailInfo;
//# sourceMappingURL=EmailInfo.js.map